// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DateInputs-module-dateInputsContainer-3K0KO{display:flex;flex-direction:row;gap:10px;gap:var(--spacing-3xs, 10px);align-items:flex-start;margin-block-start:calc(10px*-1);margin-block-start:calc(var(--spacing-3xs, 10px)*-1)}[dir=rtl] .DateInputs-module-dateInput-3b20-{direction:rtl}", ""]);
// Exports
exports.locals = {
	"dateInputsContainer": "DateInputs-module-dateInputsContainer-3K0KO",
	"dateInput": "DateInputs-module-dateInput-3b20-"
};
module.exports = exports;
